import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import styles from "./Login.module.css";
import GreenRockLogo from "../../assets/images/green_rock.png";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import { useToast } from "../../hooks/useToast";
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import { useLoginMutation } from "../../store/api/authApi";
import { setCredentials } from "../../store/slices/authSlice";
import { useDispatch } from "react-redux";

const Login: React.FC = () => {
  console.log("inloop");
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const [
    login,
    { isLoading: loginInprogress, data: loginData, error: errorInLogin },
  ] = useLoginMutation();
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response: any = await login({
        email: email,
        password: password,
      }).unwrap();
      dispatch(setCredentials(response)); // assumes { user, token, refreshToken }
      localStorage.setItem("auth", JSON.stringify(response));
      navigate("/");
    } catch (err) {
      console.error("Login failed:", err);
    }
  };

  return (
    <div className={styles.container}>
       
      <div className={styles.loginBox}>
        <div className={styles.logoContainer}>
          <img
            src={GreenRockLogo}
            alt="Green Rock Logo"
            className={styles.logo}
          />
        </div>

        <div className={styles.header}>
          <p>Log in to your account to continue</p>
        </div>

        <form onSubmit={handleLogin} className={styles.form}>
          <Input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            icon={<FiMail className="inputIcon" />}
            name="email"
            autoComplete="email"
          />
          <div className="inputGroup">
            <div className="inputWrapper">
              <Input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                icon={<FiLock className="inputIcon" />}
                name="password"
                autoComplete="current-password"
                rightIcon={
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className={styles.showPasswordButton}
                    tabIndex={-1}
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                    style={{
                      color: "var(--primary-color)",
                      background: "none",
                      border: "none",
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    {showPassword ? <FiEye /> : <FiEyeOff />}
                  </button>
                }
              />
            </div>
          </div>
          <div className={styles.forgotPassword}>
            <button
              type="button"
              className={styles.link}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                cursor: "pointer",
              }}
              onClick={() => navigate("/reset-password")}
            >
              Forgot password?
            </button>
          </div>
          <Button
            type="submit"
            loading={loginInprogress}
            disabled={loginInprogress}
          >
            Log in
          </Button>
        </form>

        {/* <div className={styles.signup}>
          <p>
            Don't have an account?{" "}
            <a href="/signup" className={styles.signupLink}>
              Sign up
            </a>
          </p>
        </div> */}

        <div className={styles.terms}>
          <p>
            By continuing, you agree to Green Rock's{" "}
            <a href="/terms" className={styles.link}>
              Terms of Use
            </a>
            . Read our{" "}
            <a href="/privacy" className={styles.link}>
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
